/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} NextInputs */

const en_next = /** @type {(inputs: NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next`)
};

const fr_next = /** @type {(inputs: NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivant`)
};

const de_next = /** @type {(inputs: NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächste`)
};

const it_next = /** @type {(inputs: NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prossimo`)
};

const ru_next = /** @type {(inputs: NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Следующий`)
};

const es_next = /** @type {(inputs: NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo`)
};

const zh_cn2_next = /** @type {(inputs: NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一个`)
};

const ja_next = /** @type {(inputs: NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次`)
};

const hi_next = /** @type {(inputs: NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगला`)
};

const pt_pt2_next = /** @type {(inputs: NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo`)
};

/**
* | output |
* | --- |
* | "Next" |
*
* @param {NextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const next = /** @type {((inputs?: NextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<NextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_next(inputs)
	if (locale === "de") return de_next(inputs)
	if (locale === "it") return it_next(inputs)
	if (locale === "ru") return ru_next(inputs)
	if (locale === "es") return es_next(inputs)
	if (locale === "zh-CN") return zh_cn2_next(inputs)
	if (locale === "ja") return ja_next(inputs)
	if (locale === "hi") return hi_next(inputs)
	if (locale === "pt-PT") return pt_pt2_next(inputs)
	return en_next(inputs)
});